import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { environment } from 'environments/environment';
import {IModalResult} from './modelResult.model';
import { ModalAction} from './modelAction.enum';

@Component({
   selector: 'app-modal',
   templateUrl : 'modal.component.html'
})

export class ModalComponent implements OnInit {
  @Input() showModal: boolean;
  @Input() title: string;
  @Input() subTitle: string;
  @Input() cancelLabel: string;
  @Input() positiveLabel: string;

  @Output('closed') closed: EventEmitter <IModalResult> = new EventEmitter <IModalResult> ();
  @Output('loaded') loaded: EventEmitter <ModalComponent> = new EventEmitter <ModalComponent> ();
  @Output() positiveLabelAction = new EventEmitter();

  version: string = environment.version;
  error: string = null;
  isLoading = false;

  ngOnInit() {
    this.loaded.next(this);
  }

  show() {
    this.showModal = true;
  }

  hide() {
    this.showModal = false;
    this.closed.next({
      action: ModalAction.POSITIVE
    });
  }

  cancelAction() {
    this.showModal = false;
    this.closed.next({
      action: ModalAction.CANCEL
    });
    return false;
  }
}




// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/shared/components/modal/modal.component.ts